import React, { useState } from "react";
import Dialog, { DialogProps } from "components/Dialog";
import { CheckBox, Text } from "@ui-kitten/components";
import Spacer from "components/Spacer";

interface Props extends DialogProps {
  onOk: (doNotShowChecked: boolean) => void;
}

const AutoReservePopup = (props: Props) => {
  const { onOk, ...otherProps } = props;
  const [doNotShowChecked, setDoNotShowChecked] = useState(false);

  return (
    <Dialog {...otherProps} onOk={() => onOk(doNotShowChecked)}>
      <Text category="h6">Your tickets are being loaded!</Text>
      <Spacer />
      <Text>
        Please check back & refresh your page in 5 to 10 minutes. Your tickets
        will appear under the My Events tab.
      </Text>
      <Spacer />
      <Text category="c1">
        You can check your auto reserve status in the account tab, under "Your
        Plans".
      </Text>
      <Spacer />
      <CheckBox
        checked={doNotShowChecked}
        onChange={(checked) => setDoNotShowChecked(checked)}
      >
        Do not show again
      </CheckBox>
    </Dialog>
  );
};

export default AutoReservePopup;
